import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/top-teams/[slug]/page.tsx\",\"import\":\"Oswald\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"oswalds\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/PerformerPageContent/PerformerPageContent.tsx");
